import { render, staticRenderFns } from "./SalaryContainer.vue?vue&type=template&id=1313809e&scoped=true&"
import script from "./SalaryContainer.vue?vue&type=script&lang=js&"
export * from "./SalaryContainer.vue?vue&type=script&lang=js&"
import style0 from "./SalaryContainer.vue?vue&type=style&index=0&id=1313809e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1313809e",
  null
  
)

export default component.exports